import { Paper } from '@mui/material';
import type * as pdfjsLib from 'pdfjs-dist';
import React from 'react';
import { getSelectorAttribute, lightInvoicePageSelectors } from '@vy/app-selectors';
import { usePdfRenderer } from '../../../../../hooks/use-pdf-renderer';

type PdfViewerPageProps = {
  page: pdfjsLib.PDFPageProxy;
};

export const PdfViewerPage: React.FC<PdfViewerPageProps> = ({ page }) => {
  const canvasRef = usePdfRenderer({ page });

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        maxWidth: '90vh',
      }}
    >
      <canvas className="grow block min-w-[0px]" ref={canvasRef} {...getSelectorAttribute(lightInvoicePageSelectors.pdfViewerCanvas)} />
    </Paper>
  );
};
